import { IBaseIconProps } from "./IBaseIconProps";

export const CashRegisterIcon = ({ color = "#000" }: IBaseIconProps) => {
  return (
    <svg
      fill={color}
      height="800px"
      width="800px"
      version="1.2"
      baseProfile="tiny"
      viewBox="-390 120 350 350"
    >
      <path
        d="M-116.4,345.9l-15.2-125.8h-30.5v-15.2h40.5v-49.7h-97.1v49.7h41.5v15.2H-243v-38.8h-50.8v38.8h-20.6l-15.2,125.8h-15.2
	v56.9h243.7v-56.9H-116.4z M-153.7,254c5.6,0,10.2,4.6,10.2,10.2c0,5.6-4.6,10.2-10.2,10.2c-5.6,0-10.2-4.6-10.2-10.2
	C-163.9,258.6-159.3,254-153.7,254z M-143.5,305.6c0,5.6-4.6,10.2-10.2,10.2c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2
	C-148.1,295.4-143.5,299.9-143.5,305.6z M-210.4,195v-29h80.4v29H-210.4z M-186.7,254c5.6,0,10.2,4.6,10.2,10.2
	c0,5.6-4.6,10.2-10.2,10.2c-5.6,0-10.2-4.6-10.2-10.2C-196.9,258.6-192.3,254-186.7,254z M-186.7,295.4c5.6,0,10.2,4.6,10.2,10.2
	c0,5.6-4.6,10.2-10.2,10.2c-5.6,0-10.2-4.6-10.2-10.2C-196.9,300-192.3,295.4-186.7,295.4z M-287.8,250.5v-30.4v-32.8h38.8v32.8
	v30.5v16.6h-38.8V250.5z M-299.1,258.5h5.3v14.6h50.8v-14.6h4.8l3.9,19.5H-303L-299.1,258.5z M-116.4,390.4h-213.2v-20.2h213.2
	L-116.4,390.4L-116.4,390.4z"
      />
    </svg>
  );
};
